import { ComponentType } from 'react';
import { Country } from '../../api';
import { HOCSelectProps } from './types';
import useResolveData from '../hooks/useResolvedData';
import LanguageSelectWrapper from './LanguageSelectWrapper';

/**
 * @Component functional Select component
 * @countries countries for select in Country type format
 * Use with already functional and independent Select component, which you
 * need to enhance with languages for specific country.
 *
 * If used with Select wrapped, in withCountries or withCountriesPreset,
 * language select options will depend on country selected in country select
 * Select props interface has to extend HOCSelectProps
 */
export const withCountryLanguages =
  <P extends HOCSelectProps>(
    Component: ComponentType<P>,
    countries: Country[] | Promise<Country[]>
  ): ComponentType<P> =>
    (props: P) => {
      const { resolvedData, error, loading } = useResolveData(countries);

      return <LanguageSelectWrapper
        {...props}
        Component={Component}
        countries={resolvedData || []}
        error={error}
        loading={loading}
      />
    };

